import React, {useEffect} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {Button, Dialog, DialogContent, DialogTitle, Stack, Typography,} from '@mui/material';
import {yupResolver} from '@hookform/resolvers/yup';
import {useGetNC, useUpdateNC, validationSchemaNC} from './Services';
import {NC} from './types';
import * as Yup from "yup";
import {FormField} from '../../common/FormField';
import {useFieldsNC_1, useFieldsNC_2, useFieldsNC_3, useFieldsNC_4} from './FormNC';

interface EditNCProps {
  open: boolean;
  onClose: () => void;
  idncprop: number;
}

const EditNC: React.FC<EditNCProps> = ({ open, onClose,idncprop   }) => {

      type NCForm = Yup.InferType<typeof validationSchemaNC>


  const { control, handleSubmit, reset,watch,setValue } = useForm<NCForm>({
    resolver: yupResolver(validationSchemaNC),

  });


  const f1 = useFieldsNC_1();
  const f2 = useFieldsNC_2();
  const f3 = useFieldsNC_3(setValue);
  const f4 = useFieldsNC_4();

 const { data, isLoading } = useGetNC(idncprop);
  const { mutateAsync, isPending } = useUpdateNC();

useEffect(() => {
  if (!data) return;


  reset({
    ...data,
  });
}, [data, reset]);




  const onSubmit: SubmitHandler<NCForm> = async data => {
    // console.log("FINAL FORM DATA:", data);

    const payload = {
                  ...data,
                };

    await mutateAsync(payload as NC);
    onClose();
  };





  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">Edit NC</Typography>
      </DialogTitle>

      <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
    <Stack direction="row" spacing={1}>{f1.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
    <Stack direction="row" spacing={1}>{f2.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
    <Stack direction="row" spacing={1}>{f3.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
    <Stack direction="row" spacing={1}>{f4.map(f => <FormField key={String(f.name)} control={control} field={f}/>)}</Stack>
     <Stack direction="row" justifyContent="flex-end" spacing={2}>
                          <Button onClick={onClose} color="error">Annulla</Button>
                          <Button type="submit" variant="contained" disabled={isPending }>
                              {isPending ? 'Salvando…' : 'Salva'}
                          </Button>
                      </Stack>

          </form>
      </DialogContent>
    </Dialog>

  </>

  );
};

export default EditNC;
